import { IParameterSchema } from "./IProcessData";

const HttpHeadersParameterSchema: IParameterSchema = {
    name: "httpHeaders",
    type: "List<KeyValuePair<string,string>>",
    inputType: "expression",
    parameterType: "ArrayParameter",
    parameterTemplate: {
        name: "Headers",
        type: "List<KeyValuePair<string,string>>",
        inputType: "expression",
        parameterType: "ComplexParameter",
        parameterTemplate: null,
        subParameters: [
            {
                name: "Key",
                type: "System.String",
                inputType: "text",
                parameterType: "TextParameter",
                subParameters: null,
                defaultValue: null,
                isSecret: false
            },
            {
                name: "Value",
                type: "System.String",
                inputType: "text",
                parameterType: "TextParameter",
                subParameters: null,
                defaultValue: null,
                isSecret: false
            }
        ],
        defaultValue: null,
        isSecret: false
    },
    subParameters: null,
    defaultValue: null,
    isSecret: false
};

export const HttpResultParameterSchema: IParameterSchema = {
    name: "httpResult",
    type: "System.Object",
    inputType: "text",
    parameterType: "ComplexParameter",
    defaultValue: null,
    isSecret: false,
    subParameters: [
        {
            name: "httpStatusCode",
            type: "System.Int32",
            inputType: "number",
            parameterType: "TextParameter",
            defaultValue: "200",
            isSecret: false,
            subParameters: []
        },
        {
            name: "httpContent",
            type: "System.String",
            inputType: "text",
            parameterType: "TextParameter",
            defaultValue: "",
            isSecret: false,
            subParameters: [],
            defaultDisplayType: "json"
        },
        {
            name: "httpContentType",
            type: "System.String",
            inputType: "text",
            parameterType: "TextParameter",
            defaultValue: "\"application/json\"",
            isSecret: false,
            description: "The content type for the response. If empty, will use text/plain",
            subParameters: []
        },
        {
            name: "httpContentEncoding",
            type: "System.String",
            inputType: "text",
            parameterType: "TextParameter",
            defaultValue: "\"utf-8\"",
            isSecret: false,
            description: "The encoding to use for the response. If empty, will try to use the charset value from Http content type parameter, and utf-8 as default",
            subParameters: []
        },
        HttpHeadersParameterSchema
    ]
};

export const HttpBinaryResultParameterSchema: IParameterSchema = {
    name: "httpBinaryResult",
    type: "System.Object",
    inputType: "text",
    parameterType: "ComplexParameter",
    defaultValue: null,
    isSecret: false,
    subParameters: [
        {
            name: "httpStatusCode",
            type: "System.Int32",
            inputType: "number",
            parameterType: "TextParameter",
            defaultValue: "200",
            isSecret: false,
            subParameters: []
        },
        {
            name: "httpContentBytes",
            type: "System.String",
            inputType: "expression",
            parameterType: "TextParameter",
            defaultValue: "",
            isSecret: false,
            subParameters: []
        },
        {
            name: "httpContentType",
            type: "System.String",
            inputType: "text",
            parameterType: "TextParameter",
            defaultValue: "\"application/octet-stream\"",
            isSecret: false,
            subParameters: []
        },
        HttpHeadersParameterSchema
    ]
};
